import React from 'react';
import Header from '../components/Header';
import TodayDeals from '../components/TodayDeals';
import Recommended from '../components/Recommended';
import Footer from '../components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <main>
        <h2 className="section-title notranslate" translate="no">Today's Deals</h2>
        <TodayDeals />
        <h2 className="section-title notranslate" translate="no">Recommended</h2>
        <Recommended />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
